<template>
  <div class="modal-cd">
    <div class="modal-cd_denied">
      <template v-if="!isApply">
        <div class="modal-cd_icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="84.95" height="66.06" viewBox="0 0 84.95 66.06"><defs><style>.a{fill:#f2f2f2;}</style></defs><path class="a" d="M41.333,49.188,14.144,71.581V95.75a2.36,2.36,0,0,0,2.36,2.36l16.526-.043a2.36,2.36,0,0,0,2.348-2.36V81.593a2.36,2.36,0,0,1,2.36-2.36h9.438a2.36,2.36,0,0,1,2.36,2.36V95.7a2.36,2.36,0,0,0,2.36,2.367l16.52.046a2.36,2.36,0,0,0,2.36-2.36V71.565L43.59,49.188a1.8,1.8,0,0,0-2.256,0Zm42.948,15.22L71.953,54.246V33.82a1.77,1.77,0,0,0-1.77-1.77H61.925a1.77,1.77,0,0,0-1.77,1.77V44.528l-13.2-10.863a7.079,7.079,0,0,0-9,0L.627,64.408A1.77,1.77,0,0,0,.391,66.9l3.761,4.572a1.77,1.77,0,0,0,2.494.24L41.333,43.141a1.8,1.8,0,0,1,2.256,0l34.69,28.571a1.77,1.77,0,0,0,2.492-.236L84.532,66.9a1.77,1.77,0,0,0-.251-2.5Z" transform="translate(0.015 -32.05)" /></svg>
        </div>
        <div class="modal-cd_title">
          <p>К сожалению мы не доставляем по вашему адресу</p>
          <!--					<span>Оставьте e-mail и мы уведомим вас о том, когда вы сможете насладится нашей едой</span>-->
        </div>
        <div class="modal-cd_form">
          <!-- <div class="modal-cd_form_input">
						<InputText
							placeholder="Введите ваш e-mail"
							v-model="email"
						/>
					</div> -->
          <div class="modal-cd_form_submit">
            <Button @click="$emit('close-modal')">
              Проверить другой адрес
            </Button>
          </div>
        </div>
      </template>
      <template v-if="isApply">
        <template v-if="delivery.type === 'green'">
          <div class="modal-cd_apply_icon">
            <icon-light-green />
          </div>
          <div class="modal-cd_apply_title">
            <p class="text-center">
              Вы можете сделать заказ!
            </p>
            <span class="d-block text-center">ваш адрес находится в зелёной зоне!</span>
          </div>
        </template>
        <template v-if="delivery.type === 'red'">
          <div class="modal-cd_apply_icon">
            <icon-light-red />
          </div>
          <div class="modal-cd_apply_title">
            <p class="text-center">
              Вы можете сделать заказ!
            </p>
            <span class="d-block text-center">ваш адрес находится в красной зоне!</span>
          </div>
        </template>
        <template v-if="delivery.type === 'yellow'">
          <div class="modal-cd_apply_icon">
            <icon-light-yellow />
          </div>
          <div class="modal-cd_apply_title">
            <p class="text-center">
              Вы можете сделать заказ!
            </p>
            <span class="d-block text-center">ваш адрес находится в желтой зоне!</span>
          </div>
        </template>
        <div class="modal-cd_apply_info">
          <p>
            <span v-if="delivery.filialName">
              Филиал: <strong> {{ delivery.filialName }} </strong> <br>
            </span>
            <span v-if="getDeliveryTime">Среднее время доставки: <strong> {{ getDeliveryTime }}.</strong><br></span>
            <!-- Бесплатная доставка: <strong>от {{ delivery.freeDelivery || 0 }} ₽</strong>-->
            <span v-if="delivery.minOrderPrice">
              Минимальная сумма заказа: <strong> {{ delivery.minOrderPrice }} ₽</strong>
            </span>
          </p>
        </div>
        <div class="modal-cd_apply_button">
          <nuxt-link to="/menu/rolls" tag="a">
            <Button>Перейти в меню</Button>
          </nuxt-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
import InputText from '@/components/UI/InputText'
import IconLightYellow from './icons/iconLightYellow'
import IconLightGreen from './icons/iconLightGreen'
import IconLightRed from './icons/iconLignRed'

export default {
  components: { Button, InputText, IconLightYellow, IconLightGreen, IconLightRed },
  props: {
    isApply: {
      type: Boolean,
    },
    delivery: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      email: '',
    }
  },
  computed: {
    getDeliveryTime () {
      if (this.delivery.timeInDelivery) {
        const minutes = this.delivery.timeInDelivery / 60
        return minutes + ' минут'
      }
      return null
    },
  },
}
</script>

<style lang="less">
.modal-cd {
	&_denied {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 40px;
		padding-bottom: 20px;

		@media screen and (max-width: 992px) { padding-bottom: 0; }
	}

	&_icon {
		margin-bottom: 30px;

		svg {
			font-size: 66px;
		}
	}

	&_title {
		text-align: center;
		margin-bottom: 44px;

		@media screen and (max-width: 992px) { margin-bottom: 20px; }

		p {
			font-family: 'Roboto Slab', Arial, sans-serif;
			font-weight: 500;
			font-size: 25px;
			padding-bottom: 15px;

			@media screen and (max-width: 992px) { padding-bottom: 30px; }
		}

		span {
			font-family: 'Roboto', Arial, sans-serif;
			font-weight: 300;
			font-size: 14px;
		}
	}

	&_form {
		display: flex;
		flex-direction: column;
		align-items: center;

		&_input {
			max-width: 100%;
			width: 400px;
			margin-bottom: 65px;

			@media screen and (max-width: 992px) { margin-bottom: 18px; }

			input {
				text-align: center;

				&, &::placeholder { font-weight: 300; }
			}
		}

		&_submit {
			max-width: 100%;
			width: 290px;

			.button { width: 100%; }
		}
	}

	&_apply {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 25px;
		padding-bottom: 5px;

		&_icon {
			margin-bottom: 25px;

			svg {
				font-size: 100px;
			}
		}

		&_title {
			padding-bottom: 80px;
			position: relative;

			&:after {
				content: '';
				width: 135px;
				height: 12px;
				background-image: url('/separator.svg');
				background-size: contain;
				background-repeat: no-repeat;
				position: absolute;
				bottom: 39px;
				left: 50%;
				transform: translateX(-50%);
			}

			p {
				font-family: 'Roboto Slab', Arial, sans-serif;
				font-weight: 500;
				font-size: 25px;
				padding-bottom: 23px;

				@media screen and (max-width: 992px) { padding-bottom: 30px; }
			}

			span {
				font-family: 'Roboto', Arial, sans-serif;
				font-weight: 300;
				font-size: 14px;
			}
		}

		&_info {
			font-family: 'Roboto', Arial, sans-serif;
			font-weight: 300;
			font-size: 14px;
			text-align: center;
			line-height: 18px;
			margin-bottom: 55px;

			strong { font-weight: 500; }
		}

		&_button {
			a {
				max-width: 100%;
				width: 290px;
				display: flex;
				text-decoration: none;

				button { width: 100%; }
			}
		}
	}
}
</style>
